class NuCountUpHTMLElement extends HTMLElement {
    static observedAttributes = ["figure"];

    static observeHandler = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.go();
                observer.unobserve(entry.target);
            }
        });
    };
    static observer = new IntersectionObserver(
        NuCountUpHTMLElement.observeHandler,
        {
            root: null,
            rootMargin: "-25% -8%",
        },
    );

    constructor() {
        super();
        this.figure = this.getAttribute("figure");
        this.length = this.figure.length;
        this.setDuration();
    }

    connectedCallback() {
        this.active = true;

        this.setup();

        NuCountUpHTMLElement.observer.observe(this);
    }

    disconnectedCallback() {
        this.active = false;

        NuCountUpHTMLElement.observer.unobserve(this);
    }

    setup() {
        let digit = "";
        for (let i = 0; i < 10; i++) {
            digit += `<span>${i}</span>`;
        }

        this.innerHTML = this.figure
            .split("")
            .map((num) => {
                return `<span aria-label="${num}"><span aria-hidden="true">${digit}</span></span>`;
            })
            .join("");

        this.digits = this.querySelectorAll(":scope > span > span");
    }

    setDuration() {
        this.style.setProperty(
            "--duration",
            `${Math.log(parseInt(this.figure)) / Math.log(10)}s`,
        );
    }

    go() {
        for (let index = this.length - 1; index >= 0; index--) {
            const iter = this.length - index; // starting from 1

            const exponent = 10 ** (iter - 1); // Gives us whether we're working with units, 10s, 100s, 1000s
            const targetValue = Math.floor(this.figure / exponent) * exponent; // Round to the closest 1, 10, 100, 1000 etc.
            const rotate = 360 * (targetValue / 10 ** iter); // Find how many times the unit divides the final value
            this.digits[index].style.setProperty("--rotate", `-${rotate}deg`);
        }
    }

    figureChanged(oldVal, newVal) {
        if (!this.active) return;

        this.figure = newVal;
        this.length = newVal.length;

        if (oldVal.length !== newVal.length) {
            this.setup();
        }

        this.setDuration();
        this.go();
    }

    /**
     * @param {string} name
     * @param {string} oldVal
     * @param {string} newVal
     */
    attributeChangedCallback(name, oldVal, newVal) {
        this?.[`${name}Changed`](oldVal, newVal);
    }
}

customElements.define("nu-count-up", NuCountUpHTMLElement);
